module.exports = __webpack_public_path__ + "img/open-beauchef.0c779090.png";